import Vue from "vue";
import Vuex from "vuex";
import SearchOverlayWidget from "./SearchOverlayWidget.vue";
import actions from "@/apps/SearchOverlayWidget/store/actions";
import getters from "@/apps/SearchOverlayWidget/store/getters";
import mutations from "@/apps/SearchOverlayWidget/store/mutations";
import VueCompositionApi from "@vue/composition-api";
import {root} from "@/shared/store";
import SearchOverlayWidgetState from "./models/search-overlay-widget-state";

Vue.config.productionTip = false;
Vue.use(VueCompositionApi)

let SearchOverlayWidgets = document.querySelectorAll('widget-search-overlay');
if (SearchOverlayWidgets.length) {
    SearchOverlayWidgets.forEach(el => {

        let store = new Vuex.Store({
            state: new SearchOverlayWidgetState,
            actions: actions,
            getters: getters,
            mutations: mutations,
            modules: {
                root
            }
        })
         new Vue({
            el: el,
            store,
            render(h: any) {
                let language = this.$el.attributes.getNamedItem('language');
                let endpoint = this.$el.attributes.getNamedItem('endpoint');
                let labels = this.$el.attributes.getNamedItem('labels');
                let searchSettings = this.$el.attributes.getNamedItem('searchSettings');
                let employeeSettings = this.$el.attributes.getNamedItem('employeeSettings');
                let externalSearchSettings = this.$el.attributes.getNamedItem('externalSearchSettings');
                return h(SearchOverlayWidget, {
                    props: {
                        configRaw: {
                            language: language?.value ?? null,
                            endpoint: endpoint?.value ?? null,
                            labels: labels ? JSON.parse(labels.value) : null,
                            searchSettings: searchSettings ? JSON.parse(searchSettings.value) : null,
                            employeeSettings: employeeSettings ? JSON.parse(employeeSettings.value) : null,
                            externalSearchSettings: externalSearchSettings ? JSON.parse(externalSearchSettings.value) : null,
                        }                        
                    }
                });
            }
        });
    });
}
